import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { PageNumber } from '../../models/page-number';

@Component({
  selector: 'pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.scss']
})
export class PagerComponent implements OnInit, OnDestroy {
  @Input('totalPageCount') totalPageCount: Observable<number>;
  @Output() valueChange: EventEmitter<PageNumber> = new EventEmitter();

  pageCount: number = 0;
  subscription: Subscription;
  public pageNumbers: PageNumber[] = [];
  
  constructor() {

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this.totalPageCount.subscribe(pageCount => {
      if(!pageCount) {
        return;
      }

      if(this.pageCount == pageCount) {
        return;
      }

      this.pageCount = pageCount;
      this.pageNumbers = [];
      for (let i = 1; i <= pageCount; i++) {
        let pageNumber = new PageNumber();
        pageNumber.number = i;
        this.pageNumbers.push(pageNumber);
      }
  
      if (pageCount > 0) {
        this.pageNumbers[0].selected = true;
      }
    });
  }

  onPageNumberClicked(pageNumber: PageNumber): void {
    this.pageNumbers.forEach(p => p.selected = false);
    pageNumber.selected = true;
    this.valueChange.emit(pageNumber);
  }

  onPrevClicked(): void {
    let current = this.pageNumbers.find(p => p.selected == true);
    if (current.number == 1) {
      return;
    }

    this.pageNumbers.forEach(p => p.selected = false);
    current = this.pageNumbers[(current.number - 1) - 1];
    current.selected = true;
    this.valueChange.emit(current);
  }

  onNextClicked(): void {
    let current = this.pageNumbers.find(p => p.selected == true);
    if (current.number == this.pageCount) {
      return;
    }

    this.pageNumbers.forEach(p => p.selected = false);
    current = this.pageNumbers[current.number];
    current.selected = true;
    this.valueChange.emit(current);
  }

}
